import React, { Component } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  IconButton,
  TablePagination,
  Box,
  CircularProgress,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Chip,
} from "@mui/material";
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Save as SaveIcon,
  Search as SearchIcon,
} from "@mui/icons-material";
import { apiUrl } from "../../comps/apiUrl";
import { toast } from "react-toastify";

class Vinculo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: true,
      add: false,
      product: {},
      itens: [],
      filter: "", // Estado para o filtro
      page: 0, // MUI paginação começa em 0
      rowsPerPage: 10,
      dados: { cat: "", sub: "", idu: "" },
      edit: {},
      edit_state: {},
      trash: {},
      loaderNew: false,
      loaderDelete: false,
    };
  }

  componentDidMount() {
    document.title = "Vinculo";
    this.fetchData();
  }

  fetchData = () => {
    const id = window.location.pathname.split("/").pop();
    fetch(`${apiUrl}/v2/equipment/get/itens/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: localStorage.getItem("token"),
      },
    })
      .then((res) => res.json())
      .then((data) => {
        this.setState({
          product: data.product || {},
          itens: data.itens || [],
          loader: false,
        });
      })
      .catch(() => {
        toast.error("Erro ao carregar dados");
        this.setState({ loader: false });
      });
  };

  // Funções de manipulação de Input
  handleChange = (e) => {
    const { id, value } = e.target;
    this.setState((prev) => ({
      dados: { ...prev.dados, [id]: value },
    }));
  };

  handleEditChange = (e) => {
    const { name, value } = e.target; // Usando name para Selects do MUI
    this.setState((prev) => ({
      edit: { ...prev.edit, [name || e.target.id]: value },
    }));
  };

  // Lógica de Paginação
  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: parseInt(event.target.value, 10), page: 0 });
  };

  // Ações de API
  handleSaveNew = () => {
    const { dados } = this.state;
    const ref = window.location.pathname.split("/").pop();
    this.setState({ loaderNew: true });
    fetch(`${apiUrl}/v2/equipment/item/add`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: localStorage.getItem("token"),
      },
      body: JSON.stringify({ ...dados, ref }),
    }).then((res) => {
      if (res.status === 401) return toast.warn("Código já cadastrado!");
      if (res.ok) {
        res.json().then((data) => {
          this.setState((prev) => ({
            itens: [{ ...dados, id: data.id, state: null }, ...prev.itens],
            add: false,
            dados: { cat: "", sub: "", idu: "" },
            loaderNew: false,
          }));
          toast.success("Item adicionado!");
        });
      }
    });
  };

  handleDelete = () => {
    const { trash } = this.state;
    this.setState({ loaderDelete: true });
    fetch(`${apiUrl}/v2/equipment/item/delete`, {
      method: "DELETE",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        authorization: localStorage.getItem("token"),
      },
      body: JSON.stringify({ id: trash.id, ref: trash.ref }),
    }).then((res) => {
      if (res.ok) {
        this.setState((prev) => ({
          itens: prev.itens.filter(
            (i) => (i.id_item || i.id) !== (trash.id_item || trash.id)
          ),
          trash: {},
        }));
        toast.success("Excluído com sucesso");
      }
    });
  };

  handleUpdate = () => {
    const { edit } = this.state;

    var ref = window.location.pathname.split("/").pop();

    var { id, ref, cat, sub, idu, state } = edit;

    fetch(`${apiUrl}/v2/equipment/item/update/`, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        authorization: localStorage.getItem("token"),
      },

      body: JSON.stringify({ id, ref, cat, sub, idu, state }),
    }).then((res) => {
      if (res.status === 401) return toast.warn("Código já existe!");
      if (res.ok) {
        this.setState((prev) => ({
          itens: prev.itens.map((i) => (i.id === edit.id ? edit : i)),
          edit: {},
        }));
        toast.success("Atualizado com sucesso");
      }
    });
  };

  handleUpdate_state = () => {
    const { edit_state } = this.state;

    var ref = window.location.pathname.split("/").pop();

    var { id, ref, state } = edit_state;

    fetch(`${apiUrl}/v2/equipment/item/update/state/`, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        authorization: localStorage.getItem("token"),
      },

      body: JSON.stringify({ id, ref, state }),
    }).then((res) => {
      if (res.status === 401) return toast.warn("Código já existe!");
      if (res.ok) {
        this.setState((prev) => ({
          itens: prev.itens.map((i) =>
            i.id === edit_state.id ? edit_state : i
          ),
          edit_state: {},
        }));
        toast.success("Atualizado com sucesso");
      }
    });
  };

  render() {
    const { itens, filter, page, rowsPerPage, loader, product } = this.state;

    // Lógica de Filtro
    const filteredItens = itens.filter(
      (item) =>
        item.cat?.toLowerCase().includes(filter.toLowerCase()) ||
        item.sub?.toLowerCase().includes(filter.toLowerCase()) ||
        item.idu?.toString().includes(filter)
    );

    if (loader) {
      return (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100vh"
        >
          <CircularProgress />
        </Box>
      );
    }

    return (
      <Box sx={{ p: 3 }}>
        <Paper sx={{ p: 2, mb: 2 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={3}
          >
            <Typography variant="h6">
              {product.descricao} - {product.codigo_barra}
            </Typography>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={() => this.setState({ add: true })}
            >
              Novo Item
            </Button>
          </Box>

          {/* Campo de Filtro */}
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Pesquisar por categoria, sub ou ID..."
            value={filter}
            onChange={(e) => this.setState({ filter: e.target.value, page: 0 })}
            sx={{ mb: 2 }}
            InputProps={{
              startAdornment: (
                <SearchIcon sx={{ color: "action.active", mr: 1 }} />
              ),
            }}
          />

          {filteredItens.length === 0 ? (
            <Box>
              <Typography variant="h6">Nenhum item encontrado.</Typography>
            </Box>
          ) : (
            <>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "100%",
                }}
              >
                <TablePagination
                  component="div"
                  count={filteredItens.length}
                  page={page}
                  onPageChange={this.handleChangePage}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={this.handleChangeRowsPerPage}
                  labelRowsPerPage="Itens por página"
                  sx={{
                    "& .MuiTablePagination-toolbar": {
                      display: "flex",
                      marginBottom: 2,
                      alignItems: "center",
                      justifyContent: "flex-end", // Garante o alinhamento à direita dentro da toolbar
                      flexWrap: "nowrap", // Força tudo a ficar na mesma linha
                    },
                    "& .MuiTablePagination-selectLabel": {
                      margin: 0, // Remove margens que podem desalinhada verticalmente
                    },
                    "& .MuiTablePagination-displayedRows": {
                      margin: 0,
                    },
                    "& .MuiTablePagination-actions": {
                      marginLeft: 1, // Espaço entre o texto das páginas e as setas
                    },
                  }}
                />
              </Box>
              <TableContainer>
                <Table size="small">
                  <TableHead sx={{ backgroundColor: "#f5f5f5" }}>
                    <TableRow>
                      <TableCell>
                        <strong>Categoria</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Subcategoria</strong>
                      </TableCell>
                      <TableCell>
                        <strong>ID Unitário</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Código</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Em uso</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Estado</strong>
                      </TableCell>
                      <TableCell align="center">
                        <strong>Ações</strong>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredItens
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((item, index) => (
                        <TableRow key={index} hover>
                          <TableCell>{item.cat}</TableCell>
                          <TableCell>{item.sub}</TableCell>
                          <TableCell>{item.idu}</TableCell>
                          <TableCell>{`${item.cat}.${item.sub}.${item.idu}`}</TableCell>
                          <TableCell>
                            {item.available == 0 ? (
                              <Chip
                                label="Sim"
                                component="a"
                                href={`/location/details/${item.token}`}
                                target="_blank"
                                color="success"
                                variant="outlined"
                                clickable
                              />
                            ) : (
                              <Chip
                                label="Não"
                                color="error"
                                variant="outlined"
                              />
                            )}
                          </TableCell>
                          <TableCell>
                            <Chip
                              onClick={() =>
                                this.setState({ edit_state: item })
                              }
                              label={
                                item.state === null
                                  ? "A Definir"
                                  : item.state === 1
                                  ? "Em Ordem"
                                  : "Em manutenção"
                              }
                              color={
                                item.state === null
                                  ? "warning"
                                  : item.state === 1
                                  ? "success"
                                  : "error"
                              }
                              variant="outlined"
                            />
                          </TableCell>
                          <TableCell align="center">
                            <IconButton
                              color="primary"
                              onClick={() => {
                                console.log(item);
                                this.setState({ edit: item });
                              }}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                            <IconButton
                              color="error"
                              onClick={() => this.setState({ trash: item })}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <TablePagination
                component="div"
                count={filteredItens.length}
                page={page}
                onPageChange={this.handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={this.handleChangeRowsPerPage}
                labelRowsPerPage="Itens por página"
                sx={{
                  "& .MuiTablePagination-toolbar": {
                    display: "flex",
                    marginTop: 2,
                    alignItems: "center",
                    justifyContent: "flex-end", // Garante o alinhamento à direita dentro da toolbar
                    flexWrap: "nowrap", // Força tudo a ficar na mesma linha
                  },
                  "& .MuiTablePagination-selectLabel": {
                    margin: 0, // Remove margens que podem desalinhada verticalmente
                  },
                  "& .MuiTablePagination-displayedRows": {
                    margin: 0,
                  },
                  "& .MuiTablePagination-actions": {
                    marginLeft: 1, // Espaço entre o texto das páginas e as setas
                  },
                }}
              />
            </>
          )}
        </Paper>

        {/* MODAL NOVO ITEM */}
        <Dialog
          open={this.state.add}
          onClose={() => this.setState({ add: false })}
          fullWidth
          maxWidth="xs"
        >
          <DialogTitle>Novo Item</DialogTitle>
          <DialogContent>
            <TextField
              fullWidth
              margin="dense"
              id="cat"
              label="Categoria"
              onChange={this.handleChange}
              inputProps={{ maxLength: 3 }}
            />
            <TextField
              fullWidth
              margin="dense"
              id="sub"
              label="Subcategoria"
              onChange={this.handleChange}
              inputProps={{ maxLength: 3 }}
            />
            <TextField
              fullWidth
              margin="dense"
              id="idu"
              label="ID Unitário"
              onChange={this.handleChange}
              inputProps={{ maxLength: 3 }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ add: false })}>
              Cancelar
            </Button>
            <Button
              variant="contained"
              loading={this.state.loaderNew}
              onClick={this.handleSaveNew}
              startIcon={<SaveIcon />}
            >
              Salvar
            </Button>
          </DialogActions>
        </Dialog>

        {/* MODAL EDITAR */}
        <Dialog
          open={Object.keys(this.state.edit).length > 0}
          onClose={() => this.setState({ edit: {} })}
          fullWidth
          maxWidth="xs"
        >
          <DialogTitle>Editar Item</DialogTitle>
          <DialogContent>
            <TextField
              fullWidth
              margin="dense"
              name="cat"
              label="Categoria"
              value={this.state.edit.cat || ""}
              onChange={this.handleEditChange}
            />
            <TextField
              fullWidth
              margin="dense"
              name="sub"
              label="Subcategoria"
              value={this.state.edit.sub || ""}
              onChange={this.handleEditChange}
            />
            <TextField
              fullWidth
              margin="dense"
              name="idu"
              label="ID Unitário"
              value={this.state.edit.idu || ""}
              onChange={this.handleEditChange}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ edit: {} })}>
              Cancelar
            </Button>
            <Button
              variant="contained"
              onClick={this.handleUpdate}
              startIcon={<SaveIcon />}
            >
              Atualizar
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={Object.keys(this.state.edit_state).length > 0}
          onClose={() => this.setState({ edit_state: {} })}
          fullWidth
          maxWidth="xs"
        >
          <DialogTitle>Editar Estado do Item</DialogTitle>
          <DialogContent>
            <FormControl fullWidth margin="dense">
              <InputLabel>Estado do Equipamento</InputLabel>
              <Select
                name="state"
                value={this.state.edit_state.state ?? ""}
                label="Estado do Equipamento"
                onChange={(event) => {
                  this.setState({
                    edit_state: {
                      ...this.state.edit_state,
                      state: event.target.value,
                    },
                  });
                }}
              >
                <MenuItem value={1}>Em Ordem</MenuItem>
                <MenuItem value={0}>Em Manutenção</MenuItem>
              </Select>
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ edit_state: {} })}>
              Cancelar
            </Button>
            <Button
              variant="contained"
              onClick={this.handleUpdate_state}
              startIcon={<SaveIcon />}
            >
              Atualizar
            </Button>
          </DialogActions>
        </Dialog>

        {/* MODAL EXCLUIR */}
        <Dialog
          open={Object.keys(this.state.trash).length > 0}
          onClose={() => this.setState({ trash: {} })}
        >
          <DialogTitle>Confirmar Exclusão</DialogTitle>
          <DialogContent>
            <Typography>
              Deseja realmente excluir este item? Esta ação não pode ser
              desfeita.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ trash: {} })}>
              Cancelar
            </Button>
            <Button
              color="error"
              variant="contained"
              onClick={this.handleDelete}
            >
              Excluir
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    );
  }
}

export default Vinculo;
